// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"503":"19e5a4ba","755":"062d7a36"}[chunkId] + ".chunk.js";
};